<template>
  <div>
    <!-- Logo -->
    <sc-link v-if="fields && fields.logoLink" :field="fields.logoLink" class="c-site__logo">
      <sc-image v-if="isMobileLogo" :media="fields.logoMobile" class="c-site__logo--m" />
      <sc-image v-else :media="fields.logo" class="c-site__logo--d" />
    </sc-link>

    <!-- Global Links & Navigation -->
    <div class="c-site__nav-container" ref="sideNav">
      <div class="c-site__nav-container-padding">
        <!-- Mobile Close Button -->
        <div class="c-nav-controls">
          <button
            type="button"
            class="c-button__close"
            @click="closeMenu()"
            aria-label="Mobile Close Menu Button"
          ></button>
        </div>
        <div class="c-header-utility" aria-label="Utility Navigation">
          <!-- Utility Links -->
          <div class="c-header-utility__item">
            <sc-placeholder name="jss-global-links" :rendering="rendering" />
          </div>
          <!-- Alert -->
          <sc-placeholder name="jss-alert" :rendering="rendering" />
        </div>
        <!-- Main Navigation -->
        <nav class="c-nav" role="navigation" aria-label="Main Navigation">
          <div class="c-nav__list">
            <sc-placeholder
              name="jss-nav"
              :class="{ editMode: isEditing }"
              :rendering="rendering"
            />
          </div>
        </nav>
      </div>
    </div>
    <!-- Search -->
    <div class="c-site__search" :class="{ open: isOpen }">
      <div class="wrapper">
        <button
          type="button"
          class="c-search-button"
          @click="openSearch()"
          aria-label="Search Open Button"
        ></button>
        <input
          class="c-search-input"
          placeholder=""
          ref="search"
          v-on:keyup.enter="submit()"
          v-model="search"
          aria-label="Search"
        />
        <button
          type="button"
          class="c-search-submit"
          @click="submit()"
          aria-label="Search Submit Button"
        ></button>
        <button
          type="button"
          class="c-search-close"
          @click="closeSearch()"
          aria-label="Search Close Button"
        ></button>
      </div>
    </div>
    <!-- Mobile Hamburger -->
    <button
      type="button"
      class="c-site__hamburger"
      @click="openMenu"
      aria-label="Mobile Hamburger Button"
    >
      <span class="hamburger-inner"></span>
    </button>
  </div>
</template>

<script>
import { Placeholder, Image, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Header',
  components: {
    ScImage: Image,
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      isOpen: false,
      isActive: '',
      isMobileLogo: false,
      search: null
    };
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    },
    routeData() {
      return this.$jss.routeData();
    }
  },
  mounted() {
    this.handleView();
    const navList = document.querySelector('.c-nav__list');

    if (navList) {
      navList.classList.add('loaded');
    }

    window.addEventListener('resize', this.handleView);
  },
  methods: {
    handleView() {
      this.isMobileLogo = document.body.clientWidth <= 1200;

      const site = document.querySelector('.c-site');

      if (document.body.clientWidth >= 992) {
        if (site) {
          site.style.transform = '';
          site.style.transition = '';
        }

        if (this.$refs.sideNav) {
          this.$refs.sideNav.style.right = '';
          this.$refs.sideNav.style.width = '';
          this.$refs.sideNav.style.transform = '';
          this.$refs.sideNav.style.transition = '';
        }

        const dropdown = document.querySelectorAll('.c-nav-dropdown');
        if (dropdown) {
          for (var x = 0; x < dropdown.length; x++) {
            dropdown[x].style.visibility = '';
          }
        }
      } else {
        let width = document.body.clientWidth + 'px';
        const activeDropDown = document.querySelector('.c-nav__item.selected .c-nav-dropdown');

        if (this.$refs.sideNav) {
          this.$refs.sideNav.style.right = '-' + width;
          this.$refs.sideNav.style.width = width;
        }
        if (site && site.style.transform) {
          site.style.transform = `translate3d(-${width}, 0px, 0px )`;
        }

        if (activeDropDown) {
          this.$refs.sideNav.style.transform = `translate3d(-${width}, 0px, 0px )`;
          document.querySelector('.c-nav__item.selected .c-nav-dropdown').style.width = width;
          document.querySelector('.c-nav__item.selected .c-nav-dropdown').style.right = '-' + width;
        }
      }
    },
    openSearch() {
      if (this.routeData.name != 'search') {
        this.isOpen = true;
        const magnifier = document.querySelector('.c-search-button');
        magnifier.style.setProperty('cursor', 'default');
        this.$nextTick(() => this.$refs.search.focus());
      } else {
        document.getElementById('keywordInput').focus();
      }
    },
    closeSearch() {
      this.isOpen = false;
      const magnifier = document.querySelector('.c-search-button');
      magnifier.style.setProperty('cursor', 'pointer');
    },
    submit() {
      if (this.search === null || this.search === '') {
        this.closeSearch();
      } else {
        window.location.href = '/search?s=' + this.search;
        this.isOpen = false;
        this.search = '';
      }
    },
    openMenu() {
      if (document.body.clientWidth <= 991) {
        let width = document.body.clientWidth + 'px';
        const site = document.querySelector('.c-site');

        this.$refs.sideNav.style.right = '-' + width;
        this.$refs.sideNav.style.width = width;

        if (site) {
          site.style.transform = `translate3d(-${width}, 0px, 0px )`;
          site.style.transition = 'all 0.5s ease 0s';
        }

        const dropdown = document.querySelectorAll('.c-nav-dropdown');
        if (dropdown) {
          for (var x = 0; x < dropdown.length; x++) {
            dropdown[x].style.visibility = 'visible';
          }
        }
      }
    },
    closeMenu() {
      if (document.body.clientWidth <= 991) {
        this.$refs.sideNav.style.width = '0px';
        const site = document.querySelector('.c-site');

        if (site) {
          site.style.transform = '';
          site.style.transition = 'all 0.5s ease 0s';
        }

        const dropdown = document.querySelectorAll('.c-nav-dropdown');
        if (dropdown) {
          for (var x = 0; x < dropdown.length; x++) {
            dropdown[x].style.visibility = '';
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
.c-site {
  &__header {
    position: relative;
    max-width: none;

    .jss-placeholder {
      padding-right: 0 !important;
      max-width: $main-max-width;
      margin: auto;
      > div {
        display: flex;
        flex-wrap: wrap;

        @include desktop-up {
          min-height: 10rem;
          justify-content: flex-end;
        }

        > span {
          width: 100%;
        }
      }
    }
  }

  &__nav-container {
    @include desktop-down {
      height: 100%;
      width: 0;
      position: fixed;
      z-index: 1000;
      top: 0;
      right: 0;
      background-color: $white;
      overflow-x: hidden;
      transition: 0.5s;

      display: flex;
      flex-direction: column;
    }

    @include desktop-up {
      text-align: right;
      padding: 1.5rem 10rem 0 0;
    }

    @include large-desktop-up {
      padding: 1.5rem 14rem 0 0;
    }

    &-padding {
      display: flex;
      flex-direction: column;
      padding: 2rem;

      @include desktop-up {
        padding: 0;
      }
    }
  }

  &__logo {
    @include margin-y(1rem, 0);
    margin-right: auto;
    &--d {
      max-width: 24rem;
      height: auto;

      @include exlarge-desktop-up {
        max-width: 30rem;
      }
    }
    &--m {
      max-width: 15.5rem;
      height: auto;
    }
    padding-left: 2rem;
    @include desktop-up {
      padding-left: 7rem;
    }
    @include exlarge-desktop-up {
      padding-left: 0;
    }
    @media (max-width: 158rem) and (min-width: $main-max-width) {
      padding-left: calc(72rem - 45.5vw);
    }
  }

  &__search {
    box-sizing: content-box;
    transition: width 0.2s ease-in-out;
    max-width: $main-max-width;

    @include desktop-up {
      position: absolute;
      z-index: 1;
      width: 8rem;
      height: 8.8rem;
      background: linear-gradient(
        169deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 59, 92, 1) 20%,
        rgba(0, 134, 191, 1) 100%
      );
      overflow: hidden;
    }

    @include large-desktop-up {
      width: 11rem;
      height: 10rem;
    }

    .c-search-input {
      display: none;
      width: 100%;
      height: 5rem;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      border: none;
      background-color: transparent;
      outline: none;
      @include font-styles('Arial Narrow', 1.8rem, 100, normal, 1.8rem, 0, $white);

      @include desktop-up {
        font-size: 5rem;
        line-height: 5rem;
        height: 7rem;
      }

      &::-webkit-input-placeholder {
        color: $white;
      }
      &::-moz-placeholder {
        color: $white;
      }
      &:-ms-input-placeholder {
        color: $white;
      }
      &:-moz-placeholder {
        color: $white;
      }
    }

    .c-search-button {
      border: none;
      cursor: pointer;
      width: 2.4rem;
      height: 2.4rem;
      background-image: url(~@/assets/images/icon-search-blue.svg);
      background-color: transparent;
      background-repeat: no-repeat;
      background-size: contain;
      margin: 3rem 1rem;

      @include desktop-up {
        width: 8rem;
        height: 8.8rem;
        background-image: url(~@/assets/images/icon-search.svg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 4rem;
        margin: 0;
      }

      @include large-desktop-up {
        width: 11rem;
        height: 10rem;
      }
    }

    .c-search-submit {
      display: none;
      width: 2rem;
      height: 4rem;
      background-image: url(~@/assets/images/icon-arrow-right-white.svg);
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 2rem;
      border: none;
      cursor: pointer;
      border-right: solid 0.1rem rgba(255, 255, 255, 0.3);
      padding-right: 4rem;

      @include desktop-up {
        background-repeat: no-repeat;
        background-position: calc(100% - 2rem) 50%;
        width: 11rem;
        height: 6rem;
        background-size: 4rem;
        margin: 0;
        padding-right: 2rem;
      }
    }

    .c-search-close {
      display: none;
      width: 2rem;
      height: 2rem;
      background-image: url(~@/assets/images/icon-close-white.svg);
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      border: none;
      cursor: pointer;
      margin: 0 2rem 0 1.5rem;

      @include desktop-up {
        width: 4rem;
        height: 4rem;
        margin: 0;
        padding: 0 4rem;
      }
    }

    &.open {
      @include desktop-down {
        position: absolute;
        z-index: 1;
        right: 0;
      }

      width: 100%;
      height: 8.5rem;
      right: auto;
      margin-left: -2rem;

      display: flex;
      background: linear-gradient(
        169deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 59, 92, 1) 20%,
        rgba(0, 134, 191, 1) 100%
      );
      overflow: hidden;
      align-items: center;

      @include desktop-up {
        height: 5.8rem;
        padding: 1.5rem 0;
      }

      @include large-desktop-up {
        height: 7rem;
        padding: 1.5rem 0;
      }

      .wrapper {
        height: 100%;
        width: 100%;
        max-width: $main-max-width;
        margin: auto;
        display: flex;
        align-items: center;
      }

      .c-search-input,
      .c-search-submit,
      .c-search-close {
        display: inline-block;
      }

      .c-search-button {
        background-image: url(~@/assets/images/icon-search.svg);
        @include phone-only {
          width: 2.3rem;
          height: 2.3rem;
          background-color: transparent;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
    }
  }

  &__hamburger {
    border: none;
    background-color: transparent;
    width: 2.1rem;
    height: 2.1rem;
    display: inline-block;
    position: relative;
    margin: 3rem 2rem 3rem 1rem;

    @include desktop-up {
      display: none;
    }

    .hamburger-inner {
      width: 2.1rem;
      height: 0.2rem;
      background-color: $blue;
      border-radius: 0;
      position: absolute;
      top: 0.3rem;
      left: 0;

      &:before,
      &:after {
        content: '';
        display: block;
        width: 2.1rem;
        height: 0.2rem;
        background-color: $blue;
        border-radius: 0;
        position: absolute;
      }

      &:before {
        top: 0.7rem;
      }

      &:after {
        top: 1.4rem;
      }
    }
  }
}

a.c-site__logo {
  line-height: 0;
  font-size: 0;
  color: transparent;
}

.c-header-utility {
  order: 2;
  list-style-type: none;
  margin: 3rem 0;
  padding: 0;

  @include desktop-up {
    display: flex;
    order: 1;
    margin: 0 0 0.5rem 0;
  }

  &__item {
    display: block;
    margin-bottom: 2rem;

    @include desktop-up {
      display: flex;
      margin-left: 2.5rem;
      height: 2.9rem;
      margin-bottom: 0;
      align-items: center;
    }
  }
}

.c-nav {
  order: 1;
  padding-top: 3rem;
  border-bottom: solid 0.1rem $nav-border;

  @include desktop-up {
    order: 2;
    padding-top: 0;
    margin-right: -1.5rem;
    border-bottom: none;
  }

  &__list {
    list-style-type: none;
    padding: 0;
    margin-top: 1.5rem;
    margin-bottom: 0;

    &.loaded {
      .c-nav-dropdown {
        @include desktop-up {
          display: flex;
        }
      }
    }
  }

  &__item {
    display: block;
    padding-bottom: 2rem;

    @include desktop-up {
      display: inline-block;
    }

    &:hover {
      .c-nav-dropdown {
        @include desktop-up {
          width: 100%;
          visibility: visible;
        }
      }
    }

    &.active {
      .c-nav__link {
        &:before {
          width: 100%;
          transition-duration: 0.75s;
        }
      }
    }
  }

  &__link {
    @include font-styles('Arial Narrow', 2rem, 400, normal, 2.9rem, 0, $blue);
    text-transform: uppercase;
    text-decoration: none;
    padding: 0;
    position: relative;
    display: block;

    @include desktop-up {
      font-size: 1.8rem;
      font-weight: 600;
      line-height: 2.4rem;
      display: inline-block;
      padding: 0 3.2rem 2.5rem 1.5rem;
    }

    &:hover {
      color: $blue;
      text-decoration: none;
    }

    &:focus {
      color: $blue;
      text-decoration: none;
    }

    &:before {
      @include desktop-up {
        content: '';
        width: 0;
        height: 0.3rem;
        position: absolute;
        left: 0;
        bottom: 0.3rem;
        background-color: $orange;
      }
    }

    &::after {
      content: '';
      position: absolute;
      top: 0.1rem;
      right: 0;
      display: inline-block;
      width: 1.5rem;
      height: 2.3rem;
      background-image: url(~@/assets/images/icon-chevron-right.svg);
      background-repeat: no-repeat;
      background-size: contain;

      @include desktop-up {
        top: 0.5rem;
        right: 1.5rem;
        width: 1.2rem;
        height: 0.8rem;
        background-image: url(~@/assets/images/icon-chevron.svg);
        background-repeat: no-repeat;
      }
    }
  }

  &-dropdown {
    height: 100vh;
    width: 0;
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    background-color: $white;
    overflow-x: hidden;
    transition: 0.5s;
    visibility: hidden;

    @include desktop-up {
      height: auto;
      top: auto;
      left: 0;
      z-index: 3;
      display: none;
      position: absolute;
      overflow-x: auto;
      width: 100%;
      @include padding-y(3rem, 3rem);
      text-align: left;
      justify-content: center;
      box-shadow: 0 0 5.4rem 0 rgba(0, 0, 0, 0.34);
      transition: visibility 0;
      transition-delay: 0.5s;
    }

    &__container {
      display: flex;
      flex-direction: column;
      padding: 2rem;

      @include desktop-up {
        flex-direction: row;
        padding: 0;
      }

      &.nav-full-width {
        .c-nav-content {
          @include desktop-up {
            flex-basis: 100%;
          }

          .u-flex-full {
            align-items: stretch;
            justify-content: flex-end;
          }
        }
      }
    }

    &__half {
      @include desktop-up {
        width: calc(50% - 3rem);
      }

      .nav-with-bg {
        align-self: flex-start;
        background-color: $nav-bg;
        padding: 2rem 0 3rem 2rem;
        border-radius: 1rem;
        margin-top: 1rem;

        .c-nav-dropdown__headline {
          padding-left: 5.5rem;
          padding-bottom: 2rem;
          min-height: 6rem;
          border-bottom: solid 0.1rem $divider;

          @include desktop-up {
            padding: 1rem 0 0 0;
            margin-bottom: 0;
            border: none;
          }
        }

        .c-nav-dropdown__subheadline {
          @include desktop-up {
            margin-top: 3rem;
          }
        }

        .c-link-list {
          padding-left: 1.5rem;
          padding-bottom: 1.5rem;

          @include desktop-up {
            padding: 0;
          }
        }

        .c-button {
          margin-top: 0;
          margin-left: 1.5rem;

          @include desktop-up {
            float: none;
            margin-top: 2rem;
            margin-left: 0;
          }
        }
      }

      .c-button {
        margin-top: 3rem;

        @include desktop-up {
          float: right;
          margin-top: 3rem;
        }
      }
    }

    &__content {
      @include font-styles('Arial Narrow', 1.4rem, 400, normal, 2rem, 0, $dark-gray);
      padding-bottom: 2.5rem;

      @include desktop-up {
        padding: 2rem 4rem 2rem 27%;
        max-width: 50%;
      }
    }

    &__nav-title {
      @include font-styles('Arial Narrow', 2.4rem, 200, normal, 2.9rem, 0, $black);
      margin: 0 0 3rem 0;

      @include desktop-up {
        display: none;
      }
    }

    &__headline {
      @include font-styles('Arial Narrow', 1.6rem, 700, normal, 1.9rem, 0, $dark-gray);
      margin: 0 0 1.2rem 0;
      display: block;

      @include desktop-up {
        @include font-styles('Arial Narrow', 2.4rem, 200, normal, 3rem, 0, $gray);
        margin: 0 0 1.5rem 0;
      }
    }

    &__subheadline {
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $black);
      margin: 0 0 1.5rem 0;
      display: block;
      @include desktop-up {
        margin-top: 1.5rem;
      }
      &.top {
        @include desktop-up {
          margin-top: 0;
        }
      }
    }

    &__text {
      @include font-styles('Arial Narrow', 1.6rem, 200, normal, 2rem, 0, $gray);
      display: block;
    }

    &__divider {
      display: none;

      @include desktop-up {
        display: block;
        width: 0.05rem;
        height: 100%;
        background-color: $orange;
      }
    }

    &__links {
      padding: 1.5rem 1.5rem 0.1rem 0;

      @include desktop-up {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding: 2rem 2rem 2rem 0;
        border: none;
      }

      &.nav-with-icon {
        display: block;
        position: relative;
        padding: 0 0 0 2rem;
        margin-bottom: 3.2rem;
        margin-left: 4rem;
        border-left: solid 0.1rem $orange;

        @include desktop-up {
          margin-left: 0;
          padding: 0 1rem 0 2rem;
          border-left: solid 0.1rem $orange;
        }

        .c-nav-dropdown__icon {
          position: absolute;
          top: 0;
          left: -4.5rem;
        }

        .c-link-list {
          border: none;
          padding: 0;

          @include desktop-up {
            padding-left: 0;
          }
        }
      }
    }

    .nav-full-width {
      @include desktop-up {
        width: 100%;
        display: flex;
        flex-basis: 100%;
        align-items: initial;
        justify-content: space-between;
        border-left: none;
        max-width: calc($main-max-width + 6rem);
        @include padding-x(3rem);
      }
    }

    .c-nav-controls {
      margin-bottom: 5rem;

      @include desktop-up {
        display: none;
      }
    }

    .c-nav-content {
      display: flex;

      > div {
        @include desktop-up {
          display: flex;
          align-items: center;
        }
      }

      .c-button {
        color: $blue;
      }
    }

    &.solutions {
      .c-nav-dropdown__headline {
        @include desktop-up {
          margin-bottom: 0;
        }
      }
    }
  }

  .c-link-list {
    list-style-type: none;
    padding: 0 0 0 2rem;
    border-left: solid 0.1rem $orange;

    @include desktop-up {
      width: 50%;
      padding: 0 0 0 5rem;
      border: none;
    }

    &.c-link-list-half {
      display: flex;
      flex-flow: row wrap;
      width: auto;
      padding: 0;

      > div {
        display: flex;
        flex-basis: 100%;
        flex-direction: column;
      }

      .c-link-list__item {
        @include desktop-up {
          flex-basis: calc(50% - 1.5rem);
          padding-right: 1.5rem;
          margin-bottom: auto;
        }
      }
    }

    &__item {
      padding-bottom: 1.6rem;

      @include desktop-up {
        margin-top: 1.5rem;
        padding-bottom: 0;
      }

      &:last-child {
        @include desktop-up {
          margin-bottom: 0;
        }
      }
    }

    &__link {
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $blue);
      text-decoration: none;
      display: block;
    }

    &__link--bottom {
      font-size: 1.6rem;
      position: relative;
      display: inline-block;
      margin-top: 1rem;
      margin-right: 1.5rem;

      &:after {
        content: '';
        display: inline-block;
        background-image: url(~@/assets/images/icon-arrow-blue.svg);
        background-size: contain;
        margin-left: 0.8rem;
      }
    }

    &__desc {
      @include font-styles('Arial Narrow', 1.4rem, 300, normal, 1.8rem, 0, $gray);
      margin: 0;
      display: block;
    }
  }

  .c-link-list-bottom {
    .c-cta--secondary {
      display: inline-flex;
      padding: 0.6rem 1.1rem 0.6rem 1.1rem;
      text-transform: uppercase;
      justify-content: flex-start;
      align-items: center;
      margin: 4rem 0 0 0;
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, normal, $blue);
      border-left: solid 0.4rem $blue;

      @include desktop-up {
        margin-left: 5rem;
      }

      &:after {
        content: '';
        position: relative;
        background-image: url(~@/assets/images/icon-arrow-right-blue-sm.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 1rem;
        width: 1.9rem;
        min-width: 1.9rem;
        height: 1.5rem;
        min-height: 1.5rem;
        transition: left 0.25s;
        left: 0;
      }

      &:hover,
      &:focus,
      &:active {
        color: $blue;
        text-decoration: none;
      }

      &:hover {
        &:after {
          left: 1rem;
        }
      }
    }
  }
}

.c-nav-controls {
  @include desktop-up {
    display: none;
  }
}
</style>
